/**
 * Small helpers the trivia pages share (projects/trivia). Not components,
 * so they live apart from them (the react-refresh rule).
 */

import { API_BASE_URL } from "../../constants";

export const LETTERS = ["A", "B", "C", "D"];

/** Each answer letter's tile colour, the same on the projector and phones. */
export const TILE_CLASS = {
  A: "bg-trivia-a",
  B: "bg-trivia-b",
  C: "bg-trivia-c",
  D: "bg-trivia-d",
};

/** Where players go to join: this app's own address. */
export function playUrl(origin = window.location.origin) {
  return `${origin}/play`;
}

/** The same address without the scheme, as it's typed: "mono.example/play". */
export function playAddress(origin = window.location.origin) {
  return playUrl(origin).replace(/^https?:\/\//, "");
}

/** "1st", "2nd", "3rd", "4th", …, "11th", "12th", "13th", "21st". */
export function ordinal(n) {
  const tens = n % 100;
  if (tens >= 11 && tens <= 13) return `${n}th`;
  return `${n}${{ 1: "st", 2: "nd", 3: "rd" }[n % 10] ?? "th"}`;
}

/** The credit the game owes its source. */
export const DICTIONARY_URL = "https://github.com/mattpocock/dictionary-of-ai-coding";

/**
 * Django admin's question list, on the API's own host. A function, not a
 * constant: `new URL` throws on a relative base, and at import time that
 * would take the whole app down with it.
 */
export function adminQuestionsUrl(base = API_BASE_URL) {
  try {
    return new URL("../admin/trivia/question/", base).href;
  } catch {
    return "/admin/trivia/question/";
  }
}

/**
 * Click handlers for a button that's replaced, in place, by the next one
 * (Next question → Reveal the answer now → Next question): the second
 * click of a double-click would press the replacement and skip a question
 * (the Vision Quest #325 lesson). Keyboard activation is detail 0 and
 * still acts.
 */
export function singleClick(action) {
  return {
    onClick: (event) => {
      if (event.detail > 1) return;
      action();
    },
    onMouseDown: (event) => {
      if (event.detail > 1) event.preventDefault();
    },
  };
}
